import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { GoogleMapsFactory } from '../../factories/GoogleMapsFactory'
import { EditorComponentContract } from '../EditorComponentContract'

export class GoogleMaps extends EditorComponentContract {
	constructor() {
		super(Variations)
		this.htmlBuilder = HtmlBuilder
		this.factory = new GoogleMapsFactory
	}

	elementIds() {
		return ['id']
	}

	elementClasses() {
		return ['classes']
	}

	elementContents() {
    return ['zoom', 'lat', 'lng', 'mapType', 'mapStyle', 'zoomControl', 'scaleControl', 'streetViewControl', 'icon', 'markers']
	}

	elementStyles() {
		return [
			{ id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null },
		]
	}

	info() {
		return {
			name: 'GoogleMaps',
			icon: 'fa-map',
			variations: this.variationsInfo()
		}
	}
}
